import { contentAi } from '@mi-front/api-clients';
import { copyToClipboardFormatted } from '@mi-front/core';
import { Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LanguageIcon from '@mui/icons-material/Language';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { ContentBadge, ContentBody, ContentTitle } from '../../components';

const StyledBtn = styled.button`
  color: inherit;
  border: none;
  margin-left: 10px;
  background-color: transparent;
  &:hover {
    color: var(--aqua);
    border: transparent;
  }
`;

export function UserArticleViewer({ content }: { content: contentAi.ContentDto }) {
  return (
    <Box mb={3}>
      {/* Top Badges */}
      <Box sx={{ display: 'flex', gap: '8px', mb: 2 }}>
        {/* Badge 1: Contenido generado para Web */}
        <ContentBadge
          icon={<LanguageIcon sx={{ color: '#AF52DE' }} />}
          sx={{ textTransform: 'uppercase' }}
        >
          <FormattedMessage
            id="contentAi.userArticle.generatedForWeb"
            defaultMessage="Contenido generado para Web"
          />
        </ContentBadge>

        {/* Badge 2: Artículo primario */}
        <ContentBadge
          icon={<DescriptionOutlinedIcon sx={{ color: '#AF52DE' }} />}
          sx={{ textTransform: 'uppercase' }}
        >
          <FormattedMessage
            id="contentAi.userArticle.primaryArticle"
            defaultMessage="Artículo primario"
          />
        </ContentBadge>
      </Box>

      {/* Title section */}
      <ContentTitle sx={{ mb: 2 }}>{content.userArticle.data?.title}</ContentTitle>

      {/* Collapsible content */}
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <div>
            <Typography component="span">
              <FormattedMessage
                id="contentAi.viewFullArticle"
                defaultMessage="Ver artículo completo"
              />
            </Typography>
            <Tooltip
              title={
                <FormattedMessage
                  id="contentAi.copyToClipboard"
                  defaultMessage="Copiar al portapapeles"
                />
              }
              placement="top"
            >
              <StyledBtn
                onClick={(e: React.MouseEvent) => {
                  e.stopPropagation();
                  copyToClipboardFormatted(
                    content.userArticle.data?.body && content.userArticle.data?.title
                      ? `${content.userArticle.data?.title}\n\n${content.userArticle.data?.body}`
                      : '',
                  );
                }}
              >
                <ContentCopyIcon />
              </StyledBtn>
            </Tooltip>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <ContentBody
            dangerouslySetInnerHTML={{
              __html: content.userArticle.data?.body ?? '',
            }}
          />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
